import React from 'react'
import styled from 'styled-components'
import imgx from '../../../assets/t1.png'
import dot from '../../../assets/save.svg'
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Link } from 'react-router-dom'
import bin from "../../../assets/ellipsis-vertical-svgrepo-com.svg";
import Xave from "../../../assets/save.svg";
import bookmark from '../../../assets/bookmark.png';
import { db, auth } from '../../../firebase';
import { makeStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
}));

const ItemSaved = ({
  Image,
  title,
  name,
  onclick,
  id,
  setkey,
  key,
  Setpost,
  setsavedId,
  pages
}) => {
  let saveId = [];
  const uid = auth.currentUser.uid;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id2 = open ? 'simple-popover' : undefined;
  const removeSaved = () => {
    db.collection("users").doc(uid).get().then((doc) => {
      saveId = doc.data().saved;
      let arr = [...saveId];
      arr = arr.filter(e => e !== id);
      db.collection("users").doc(uid).update({ saved: arr }).then(() => {
        var temparr = [];
        var promises = [];
        var res = db.collection("users").doc(uid);
        res.get().then((doc) => {
          var i = 0;
          var arr = doc.data().saved;
          setsavedId(doc.data().saved);
          for (i = 0; i < arr.length; i++) {
            promises.push(myFunc(arr[i]));
          }
          Promise.all(promises).then(() => {
            console.log(temparr);
            Setpost(temparr);
          });
          function myFunc(item) {
            return new Promise((resolve) => {
              var docRef = db.collection("posts").doc(item);
              docRef.get().then((doc) => {
                var data = doc.data();

                data = { ...data, id: item };
                temparr.push(data);
                console.log(data);
                resolve(temparr);
              });
            });
          }
        });
      });

    });
    handleClose();
    // setkey(!key);
  }
  return (
    <>

      <Item>
        {/* Image */}

        <div onClick={() => onclick(id)}>
          <Imagex src={Image} alt="oops nothing to show" />
        </div>

        <Body>

          <div style={{ display: 'flex' }}>
            <Title>{title}</Title>

            <span style={{ marginLeft: "auto" }}>
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}
              >
                <MoreVertIcon />
              </IconButton>


              {/* <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem
                  onClick={handleClose} 
                  onClick={removeSaved}>Remove from saved
                </MenuItem>
              </Menu> */}
              <Popover
                id={id2}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                <Typography onClick={removeSaved} className={classes.typography}>Remove from saved</Typography>
              </Popover>
            </span>
          </div>

          <div style={{ display: 'flex', alignItems: "center" }}>
            {/* <img style={{ height: '27px', width: '27px', borderRadius: '50%' }} alt="" /> */}
            <Name>{name}</Name>
          </div>
          {/* <Div>Hii</Div> */}
        </Body>


        {/* <Content>
          <div style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "baseline",
            marginTop: '-2vh'
          }}>
            <Title style={{ cursor: 'default' }}>{title}</Title>

          </div>
          <MoreVertIcon style={{fontSize: '25px', marginLeft: '38vw', marginTop: '-15vh'}}/>
          <img src={bin} onClick={handleClick} style={{ height: '3.8vh', marginLeft: '38vw', marginTop: '-12vh', cursor: 'pointer' }} />
          <Popover
            id={id2}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            onClick={removeSaved}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <Typography className={classes.typography}>Remove from saved.</Typography>
          </Popover>
          <Name style={{ cursor: 'default' }}>{name}</Name>
          <hr style={{
            position: "relative",
            height: "6px",
            border: "none",
            borderRadius: "4px",
            backgroundColor: '#babac0'

          }}></hr>

        </Content> */}


      </Item>
    </>
  )
}
const Item = styled.div`
    display:flex;
    flex-direction:row;
    margin-top: 20px;
    width: 730px;
    margin-left: 35px;
    @media (max-width: 1115px){
        width: 600px;
    };
    @media (max-width: 985px){
    margin-left: 0px;
    };
    @media (max-width: 950px){
        width: 450px;
    margin-left: 35px;
    };
    @media (max-width: 763px){
        margin-left: 0px;
      };
    @media (max-width: 500px){
        width: 320px;
    };
`

const Imagex = styled.img`
    width: 149px;
    height: 198px;
    @media (max-width: 950px){
        width: 130px;
        height: 172.75px;
    };
    @media (max-width: 500px){
        width: 105px;
        height: 140px;
    };
`

// const Item = styled.div`
//     position:relative;
//     display:flex;
//     flex-direction:row;

// `

const Body = styled.div`
width: 100%;
margin-left: 15px;
`

const BookImg = styled.img`
    width: 14px;
`

const Icon = styled.img.attrs(props => ({
}))`
    align-self: right;
`;

const Title = styled.p`
    font-size:20px;
    width: 90%;
    margin-bottom: 10px;
    overflow: hidden;
    word-break: break-word;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    @media (max-width: 950px){
    font-size:18px;
    };
    @media (max-width: 500px){
    font-size:16px;
    };
`
const Name = styled.p`
    margin: 0;
    font-family:Rubik;
    font-size:14px;
    padding-left: 8px;
    @media (max-width: 950px){
        font-size:13px;
    };
    @media (max-width: 500px){
        font-size:12px;
    };
`

const Div = styled.div`
    width: 90%;
    font-size:13px;
    margin-top: 35px;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    @media (max-width: 950px){
        font-size:12px;
    };
    @media (max-width: 500px){
        margin-top: 20px;
        font-size:11px;
    };
`


// const Content = styled.div`
// /* border:2px solid green; */
// margin:5px;
// margin-top:30px;
// padding-left:5px;

// `
// const Imagex = styled.img.attrs(props => ({
//   src: { Image }
// }))`
//     width: 120px;
//     height: 150px;
//     margin-left:20px;
//     margin-top:30px;
//     padding-left:20px;
// `
// const DotIcon = styled.img.attrs(props => ({
//   src: dot
// }))`

// `
// const Title = styled.p`
//     font-family:Rubik;
//     font-size:20px;
//     font-weight:600;
//     width: 36.65vw;
//     margin-top: 1.5vh;
//     overflow: hidden;
//     text-overflow: ellipsis;
// `
// const Name = styled.p`
//     position: relative;
//     margin-top: -6vh;
//     font-family:Rubik;
//     font-size:16px;
// `
// const Page = styled.p`
//     position: relative;
//     margin-top: 3vh;
//     font-family:Rubik;
//     font-size:15px;
//     color: #868585;
// `

export default ItemSaved